// extracted by mini-css-extract-plugin
export default {"bold":"T9kCfg","semi-bold":"oiN7lW","semiBold":"oiN7lW","container":"EgCDGa"};